import "./ManualAdjustmentDetailsModal.styles.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const ManualAdjustmentDetailsModal = ({
  open,
  originalRow,
  handleClose,
}: {
  open: boolean;
  originalRow: any;
  handleClose: () => void;
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="manual-adjustment-details-modal-dialog-title"
      aria-describedby="manual-adjustment-details-modal-dialog-description"
      className="manual-adjustment-details-modal"
    >
      <DialogTitle id="manual-adjustment-details-modal-dialog-title">
        {originalRow?.metadata?.description || "Manual Adjustment Details"}
      </DialogTitle>
      <DialogContent>
        <pre>{JSON.stringify(originalRow, null, 2)}</pre>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          className="manual-adjustment-details-modal-close-button"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManualAdjustmentDetailsModal;
